import { GovernanceField } from '../types'
import { DraggableField } from './draggable-field'

interface DraggableFieldsListProps {
  fields: GovernanceField[]
  onRemoveField: (fieldId: string) => void
}

export function DraggableFieldsList({ fields, onRemoveField }: DraggableFieldsListProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {fields.map((field, index: number) => (
        <DraggableField
          field={field}
          index={index}
          key={field.concatenation_field_id}
          onRemoveField={onRemoveField}
        />
      ))}
    </div>
  )
}
